<style>

.card{
  position: relative;
  color: white;
}

img{
  object-fit: cover;
  width: 100%;
}
.starts-in {
  position: absolute;
  top: 5px;
  left: 5px;
  padding: 5px;
  background-color: rgba(0,0,0,0.8);
}
.info{
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  padding: 5px;
  /* border: 1px red solid; */
  /* margin-top: -40px; */
  background-color: rgba(0,0,0,0.8);
}
.name{
  font-size: 21px;
}

</style>

<Notification></Notification>

<Header 
buttons="{ [ {icon: 'icon-calendar_add', text: 'Add Event', callback: 'addEvent', disabled: false, }, {icon: 'icon-equalizer', text: 'Filter Events', callback: 'filterEvents', disabled: false, }, ] }"
on:addEvent="{ () => push('/create-new-event') }"
on:filterEvents="{ () => push('/events-filter') }">Events</Header>
<div class="has-header"></div>

<Dialog show="{newUserShow}" title="" cancel="{false}" close="{false}" buttons="{ [ {text: 'No', callback: 'close', disabled: false, }, {text: 'Yes', callback: 'editProfile', disabled: false, }, ] }" on:close="{closeDialog}" on:editProfile="{editProfile}">
  <div>Looks like you're new here. Would you like to edit your profile?</div>
</Dialog>

{#each items as item, index }

<div class="card" on:click="{ () => { push('/events-info/'+item.oid) } }">
  <img src="{item.img}" alt="" class="img">
  <div class="starts-in"><StartsIn currentTime="{currentTime}" startsAt="{item.startsAt}" endsAt="{item.endsAt}"></StartsIn></div>
  <div class="info">
    <div class="name">{item.name}</div>
    <div><Stars stars="{item.stars}"></Stars></div>
    <div><EventTime startsAt="{item.startsAt}" endsAt="{item.endsAt}"></EventTime></div>
  </div>
</div>

{/each}

<div class="has-action-bar"></div>

<ActionBar></ActionBar>


<script>

import {push, pop, replace, location} from 'svelte-spa-router';

import Header from "../components/Header.svelte";
import ActionBar from "../components/ActionBar.svelte";
import Stars from "../components/Stars.svelte";
import EventTime from "../components/EventTime.svelte";
import StartsIn from "../components/StartsIn.svelte";
import Dialog from "../components/Dialog.svelte";
import Notification from "../components/Notification.svelte";

let interval = null;
let currentTime =  Math.round( Date.now() / 1000 );
import { onMount } from "svelte";
onMount(async () => {
  
  // if ( localStorage.getItem("events-new-user") == null) {
  //   localStorage.setItem("events-new-user", 1)
  // }
  // newUserShow = localStorage.getItem("events-new-user");
  
  // update the event times every X minutes
  interval = setInterval( () => { currentTime =  Math.round( Date.now() / 1000 ) }, 1000 * 60 * 1);
});

let date = Math.round( Date.now() / 1000 );

let items = [
  // {oid: "abc01def", name: "Cocktail Night At The Grove - $5 Cover", stars: 4.5, startsAt: date + (60 * 60 * 24 * 2), endsAt: date + (60 * 60 * 24 * 2) + 3600, img: "/i/event1.jpg"},
  {oid: "abc01def", name: "Cocktail Night At The Grove - $5 Cover", stars: 4.5, startsAt: date + 120, endsAt: date + 180, img: "/i/event1.jpg"},
  {oid: "def01abc", name: "Dance Party @ Club Operative", stars: 2, startsAt: date + (3600 * 24), endsAt: date + (3600 * 25), img: "/i/event2.jpg"},
]

let newUserShow = false;

function closeDialog() {
  newUserShow = false;
  localStorage.setItem("events-new-user", 0);
}


function editProfile() {
  newUserShow = false;
  localStorage.setItem("events-new-user", 0);
  push('/edit-profile');
}
</script>